import _ from 'lodash';

/**
 * Tells whether the feature flag is enabled for the user's organization
 */
export function isFeatureEnabled(user, key) {
    return _.get(user, '_embedded.organization.featureFlags', []).includes(key);
}
